import { render, staticRenderFns } from "./withdrawalRecord.vue?vue&type=template&id=4bd36a44"
import script from "./withdrawalRecord.vue?vue&type=script&lang=ts"
export * from "./withdrawalRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports